import * as React from "react";
import { observer } from "mobx-react";
import { runInAction, computed, observable, autorun } from "mobx"
import { NotificationStore, NotificationMode } from "../Stores/NotificationStore";


@observer
export class NotificationBox extends React.Component<{}, {}> {

	timeoutHandler: number;

	componentDidUpdate() {
		clearTimeout(this.timeoutHandler);
		if (NotificationStore.text && NotificationStore.duration >= 0) {
			this.timeoutHandler = setTimeout(() => runInAction(() => NotificationStore.clearMessage()), NotificationStore.duration);
		}
	}

	@computed get notificationClasses() {
		switch (NotificationStore.mode) {
			case NotificationMode.Success:
				return "app__note is--note-success is--note-show";
			case NotificationMode.Information:
				return "app__note is--note-information is--note-show";
			case NotificationMode.Error:
				return "app__note is--note-error is--note-show";
			default:
				return "app__note is--note-information";
		}
	}

	@computed get isVisible(): boolean {
		switch (NotificationStore.mode) {
			case NotificationMode.None:
				return false;
			default:
				return true;
		}
	}

	render() {
		return this.isVisible ? <div className={this.notificationClasses}>
			{NotificationStore.text}
		</div> : null;
	}
}
